<!--suppress JSUnresolvedVariable -->
<template>
  <div class="news-list bg-light pb-5">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-warning">
        <h1 class="animated fadeInDown">新闻中心</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="container content mt-5">
      <!-- 当前位置 -->
      <div class="text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">新闻中心</a>
      </div>
      <div class="row">
        <div
          class="col-12 col-lg-6 mb-3 animated zoomIn"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <el-card
            class="card mb-3 p-3 border-0"
            :body-style="{ padding: '0px' }"
            shadow="hover"
          >
            <a @click="updateGameNewsViews(item.newsId)">
              <div class="row no-gutters">
                <div class="col-md-4">
                  <a href="#">
                    <img
                      :src="item.newsCover"
                      class="w-100 img-thumbnail"
                      alt="..."
                    />
                  </a>
                </div>
                <div class="col-md-8">
                  <div class="card-body p-0 pl-4">
                    <a href="#">
                      <span
                        class="badge badge-danger badge-pill text-white  p-1 px-2 my-2 my-sm-1"
                        v-if="item.newsTag === 1"
                      >
                        hot
                      </span>
                      <span
                        class="badge badge-success badge-pill text-white  p-1 px-2 my-2 my-sm-1"
                        v-if="item.newsTag === 2"
                      >
                        置顶
                      </span>
                      <span
                        class="badge badge-info badge-pill text-white  p-1 px-2 my-2 my-sm-1"
                        v-if="item.newsTag === 3"
                      >
                        推荐
                      </span>
                    </a>
                    <h5 class="card-title">
                      <a href="#" class="text-dark">
                        {{ item.newsTitle }}
                      </a>
                    </h5>
                    <p class="card-text m-0">
                      <span class="text-danger">
                        <span class="text-muted">
                          浏览量：
                        </span>
                        {{ item.newsViews }}
                      </span>
                    </p>
                    <p class="card-text m-0">
                      <span class="text-info">
                        <span class="text-muted">
                          发布时间：
                        </span>
                        {{ item.publishTime }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </el-card>
        </div>
      </div>
      <div class="text-center mt-4">
        <a
          type="danger"
          @click="findMore()"
          class="btn text-danger text-decoration-none font-weight-bold"
          v-if="this.total !== this.newsList.length"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          加载更多
        </a>
        <el-divider v-if="this.total === this.newsList.length">
          <small class="text-muted">我可是有底线的</small>
        </el-divider>
      </div>
    </div>
  </div>
</template>

<!--suppress ES6CheckImport -->
<script>
import { WOW } from "wowjs";

export default {
  name: "NewsList",
  data() {
    return {
      sectionSubTitle: "",
      moreImgUrl: "",
      logSys: 1,
      backgroundUrl: "",
      currentPage: 1,
      pageSize: 6,
      total: 0,
      newsList: []
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getAllNewsList();
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.logSys = 3;
      } else {
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 3)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.backgroundUrl = resp.data.data.bannerImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
          }
        })
        .catch();
    },
    getAllNewsList() {
      this.axios
        .get("/news/getAllNewsList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.total = resp.data.data.total;
            this.currentPage += 1;
            this.newsList = this.newsList.concat(resp.data.data.records);
          }
        })
        .catch();
    },
    findMore() {
      this.getAllNewsList();
    },
    updateGameNewsViews(newsId) {
      this.axios
        .put("/news/updateGameNewsViews/" + newsId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$router
              .push({ name: "NewsDetail", params: { newsId: newsId } })
              .catch();
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.news-list {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  .content {
    .row {
      div {
        .card:hover {
          box-shadow: 0 0 0.5rem rgba(255, 83, 10, 0.6);
          border-radius: 0;
        }

        .card-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .news-summary {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .el-divider__text {
      background-color: #f8f9fa;
    }
  }
}
</style>
